var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerQuestionAnswerPart } from '../../scenes/showQuestion/AbfragerQuestionAnswerPart';
import { AbfragerMemorizePointsWordTask } from './AbfragerMemorizePointsWordTask';
import { AbfragerMemorizePointsRevealButtons } from './AbfragerMemorizePointsRevealButtons';
let AbfragerMemorizePointsAnswerPart = class AbfragerMemorizePointsAnswerPart extends React.PureComponent {
    render() {
        const { question } = this.props;
        return (React.createElement(AbfragerQuestionAnswerPart, { question: question },
            question.memorizePointsForUI.wordTasksToDisplay.map(task => (React.createElement(AbfragerMemorizePointsWordTask, { task: task, key: task.id }))),
            React.createElement(AbfragerMemorizePointsRevealButtons, { question: question })));
    }
};
AbfragerMemorizePointsAnswerPart = __decorate([
    observer
], AbfragerMemorizePointsAnswerPart);
export { AbfragerMemorizePointsAnswerPart };
